/**
 * 所有任务
 * 配置说明：
 * const allTasks = {
 *  任务名称：[   // 显示在任务切换按钮上
 *    {
 *      path:path,    // 必须项：在allMenus中的_path中存在, 其中每一个任务的第一项配置要能从allMenus相应条目的_component中读取到config属性
 *      tabs:[tab1, tab2]，// 可选项，如为第一个path，如无tabs，则取config或config.tabs[0]，必须存在columns配置项；不为第一项，则仅作为从后台取数据时使用
 *    }
 *  ]
 * }
 */
const allTasks = {
    // '异常考勤': [{ name: '', path: '/AbnormalAttendance', tabs: ['未处理'] },],
    // '忘刷卡申请': [{ name: '', path: '/ForgetSwipeCardApply', tabs: ['申请中', '驳回申请'] },],
    // '忘刷卡签核': [{ name: '忘刷卡签核', path: '/ForgetSwipeCardApproval' },],
    // '加班申请': [{ name: '', path: '/OverTimeApply', tabs: ['申请中', '填写中', '驳回申请'] },],
    // '加班签核': [{ name: '加班签核', path: '/OverTimeApproval' },],
    // '请假申请': [{ name: '', path: '/LeaveApplication', tabs: ['申请中', '驳回申请'] },],
    // '代理人签核': [{ name: '代理人签核', path: '/ReceivingConfirmation' },],
    // '请假签核': [{ name: '请假签核', path: '/LeaveApproval' },],
    // '出差报告上传': [{ name: '出差报告上传', path: '/TravelReportUpload' },],
    // '司机确认': [{ name: '司机确认', path: '/DriverConfirmation' },],
    // '销假申请': [{ name: '', path: '/LeaveCancellationApplication', tabs: ['申请中'] },],
    // '销假签核': [{ name: '销假签核', path: '/LeaveCancellationApproval' },],
    // '调薪申请': [{ name: '', path: '/SalaryAdjustmentApplication', tabs: ['申请中', '驳回申请'] },],
    // '调薪签核': [{ name: '调薪签核', path: '/SalaryAdjustmentApproval' },],
    // '月薪制作': [{ name: '', path: '/MonthlySalaryProduction', tabs: ['制作中'] },],
    // '月薪签核': [{ name: '月薪签核', path: '/MonthlySalaryApproval' },],
    // '加扣项确认': [{ name: '', path: '/ConfirmationDeductionItems', tabs: ['待确认'] },],
    // '加扣项处理': [{ name: '加扣项处理', path: '/DeductionProcessing', },],
    // '奖金申请': [{ name: '', path: '/BonusApplication', tabs: ['申请中', '驳回申请'] },],
    // '奖金签核': [{ name: '奖金签核', path: '/BonusApproval' },],
}


export default allTasks